//子表函数--23个
export const AnalyticalFunc = [
  {
    "key": "IsNull",
    "name": "是空值",
    "params": [
      {
        "key": "obj",
        "name": "检测对象",
        "type": "object"
      }
    ],
    "description": `【功能】判断检测对象是否为空值（null）。检测对象为null返回true，否则返回false
    【参数】
        【obj】检测对象
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含编号code字段
        【需求】判断提交单据的编号是否为null
        【举例】是空值(Order.code)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsNullOrWhiteSpace",
    "name": "是空串",
    "params": [
      {
        "key": "obj",
        "name": "检测对象",
        "type": "object"
      }
    ],
    "description": `【功能】判断检测对象是否为null值或空串""。检测对象为null或""返回true，否则返回false
    【参数】
        【obj】检测对象
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含编号code字段
        【需求】判断提交单据的编号是否为null或空串""
        【举例】是空值(Order.code)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsNaN",
    "name": "非数字",
    "params": [
      {
        "key": "obj",
        "name": "检测对象",
        "type": "object"
      }
    ],
    "description": `【功能】判断检测对象是否可以转换成数字(Double)。检测对象不能转为数字返回true，否则返回false
    【参数】
        【obj】检测对象
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含单据总额sum字段
        【需求】判断提交单据的单据总额是否为非数字
        【举例】非数字(Order.sum)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsNumber",
    "name": "是数字",
    "params": [
      {
        "key": "obj",
        "name": "检测对象",
        "type": "object"
      }
    ],
    "description": `【功能】判断检测对象是否可以转换成数字(Double)。检测对象能转为数字返回true，否则返回false
    【参数】
        【obj】检测对象
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含单据总额sum字段
        【需求】判断提交单据的单据总额是否是数字
        【举例】是数字(Order.sum)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ExistData",
    "name": "子表有无数据",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      }
    ],
    "description": `【功能】判断子表中有没有数据。有数据返回true，无数据返回false（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips
        【需求】判断差旅明细子表是否有数据
        【举例】子表有无数据("Order.trips")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "CountOfChild",
    "name": "子表数据数量",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      }
    ],
    "description": `【功能】返回子表数据的数量（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
    【返回值】数量（数值类型）
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips
        【需求】获取差旅明细子表的数量
        【举例】子表数据数量("Order.trips")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "SortChildData",
    "name": "子表数据排序",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表排序字段",
        "type": "string"
      },
      {
        "key": "order",
        "name": "排序方式",
        "type": "string"
      }
    ],
    "description": `【功能】对子表数据进行排序（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段（字段类型应为数字类型）
        【order】排序方式（"ESC"表示正序从小到大，"DESC"表示倒序从大到小）
    【返回值】无
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段
        【需求】按照出差费用money字段对差旅明细从小到大排序
        【举例】子表数据排序("Order.trips","money","ESC")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IncludedInList",
    "name": "是否在列表中",
    "params": [
      {
        "key": "property",
        "name": "字段",
        "type": "object"
      },
      {
        "key": "list",
        "name": "数据列表",
        "type": "list"
      }
    ],
    "description": `【功能】：判断字段是否在数据列表中存在。字段在列表中存在返回true，不存在返回false。支持判断字符和数字类型
    【参数】
        【property】字段
        【list】数据列表
    【返回值】true或false
    【示例】是否在列表中(Order.name,["Zs","Ls"])
    【示例】是否在列表中(Order.quantity,[100,200])`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "CountByProp",
    "name": "子表列非空数",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      }
    ],
    "description": `【功能】：统计子表某字段不为null的数据数量（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段
    【返回值】子表字段不为null的数量（数值类型）
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差方式way字段
        【需求】统计差旅明细子表trips中出差方式way不为空的数据数量
        【举例】子表列非空数("Order.trips","way")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "SumByProp",
    "name": "子表字段求和",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      }
    ],
    "description": `【功能】求和子表某字段（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段（数值类型）
    【返回值】子表某字段的和（数值类型）
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段
        【需求】对差旅明细子表trips的出差费用money字段求和
        【举例】子表字段求和("Order.trips","money")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "AvgByProp",
    "name": "子表列平均值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      }
    ],
    "description": `【功能】求子表某字段的平均值（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段（数值类型）
    【返回值】子表某字段的平均值（数值类型）
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段
        【需求】获取差旅明细子表trips的出差费用money的平均值
        【举例】子表列平均值("Order.trips","money")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MaxByProp",
    "name": "子表列最大值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      }
    ],
    "description": `【功能】求子表某字段的最大值（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段（数值类型）
    【返回值】子表某字段的最大值（数值类型）
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段
        【需求】获取差旅明细子表trips的出差费用money的最大值
        【举例】子表列最大值("Order.trips","money")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MinByProp",
    "name": "子表列最小值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      }
    ],
    "description": `【功能】求子表某字段的最小值（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段（数值类型）
    【返回值】子表某字段的最小值（数值类型）
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段
        【需求】获取差旅明细子表trips的出差费用money的最小值
        【举例】子表列最小值("Order.trips","money")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsExistRecord",
    "name": "子表有无等于匹配值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "string"
      }
    ],
    "description": `【功能】判断子表某字段是否存在等于匹配值的数据（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段
        【match】匹配值
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差方式way
        【需求】判断差旅明细子表trips是否存在出差方式way等于'火车'的数据
        【举例】子表有无等于匹配值("Order.trips","way","火车")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsContainMatch",
    "name": "子表有无包含匹配值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "string"
      }
    ],
    "description": `【功能】判断子表某字段是否存在包含匹配值的数据（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段
        【match】匹配值
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差方式way
        【需求】判断差旅明细子表trips是否存在出差方式way包含匹配值'飞机'的数据
        【举例】子表有无包含匹配值("Order.trips","way","飞机")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListGreaterThan",
    "name": "子表有无大于匹配值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "double"
      }
    ],
    "description": `【功能】判断子表某字段是否存在大于匹配值的数据（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段（数值类型）
        【match】匹配值
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差距离distance
        【需求】判断差旅明细子表trips是否存在出差距离distance大于1000的数据
        【举例】子表有无大于匹配值("Order.trips","distance",1000)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListLessThan",
    "name": "子表有无小于匹配值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "double"
      }
    ],
    "description": `【功能】判断子表某字段是否存在小于匹配值的数据（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段（数值类型）
        【match】匹配值
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差距离distance
        【需求】判断差旅明细子表trips是否存在出差距离distance小于10的数据
        【举例】子表有无小于匹配值("Order.trips","distance",10)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListStartWith",
    "name": "子表有无以匹配值开头",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "string"
      }
    ],
    "description": `【功能】判断子表某字段有无开头是匹配值的数据（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段
        【match】匹配值
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含编号code字段
        【需求】判断差旅明细子表trips是否存在编号code字段以'0001'开头的数据
        【举例】子表有无以匹配值开头("Order.trips","code","0001")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListEndWith",
    "name": "子表有无以匹配值结尾",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      },
      {
        "key": "match",
        "name": "匹配值",
        "type": "string"
      }
    ],
    "description": `【功能】判断子表某字段有无结尾是匹配值的数据（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段
        【match】匹配值
    【返回值】true或false
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含编号code字段
        【需求】判断差旅明细子表trips是否存在编号code字段以'0002'结尾的数据
        【举例】子表有无以匹配值结尾("Order.trips","code","0002")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetComputeJsonData",
    "name": "子表字段取JSON串",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "property",
        "name": "子表字段",
        "type": "string"
      }
    ],
    "description": `【功能】判断子表某字段有无结尾是匹配值的数据（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【property】子表字段
    【返回值】子表某字段的JSON格式
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含编号code字段
        【需求】将差旅明细子表trips编号code字段用一个列表统计数据，并返回序列化后的值
        【举例】子表字段取JSON串("Order.trips","code")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MultiplyChildNumber",
    "name": "子表属性乘积求和",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "prop1",
        "name": "属性一",
        "type": "string"
      },
      {
        "key": "prop2",
        "name": "属性二",
        "type": "string"
      }
    ],
    "description": `【功能】对子表的两个数字类型属性，先做乘积，然后求和（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【prop1】属性一（数值类型）
        【prop2】属性二（数值类型）
    【返回值】求和值（数值类型）
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差天数days、出差费用money
        【需求】获取差旅明细的总费用，即子表出差天数*出差费用的总和
        【举例】子表属性乘积求和("Order.trips","days","money")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MinValueOfPeriod",
    "name": "时间范围内取最小值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "timeProp",
        "name": "比较时间字段",
        "type": "string"
      },
      {
        "key": "valueProp",
        "name": "取值字段",
        "type": "string"
      },
      {
        "key": "startTime",
        "name": "起始时间",
        "type": "string"
      },
      {
        "key": "endTime",
        "name": "结束时间",
        "type": "string"
      }
    ],
    "description": `【功能】在指定时间范围内，取子表某字段的最小值（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【timeProp】比较时间字段（字段类型应为时间类型）
        【valueProp】取值字段（字段类型应为数字类型）
        【startTime】起始时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
        【endTime】结束时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
    【返回值】时间范围内，子表某字段的最小值
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段，出差日期date字段
        【需求】获取2022-10-01到2022-10-07时间段内，哪一天的出差费用money最小
        【举例】时间范围内取最小值("Order.trips","date","money","2022-10-01","2022-10-07")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MaxValueOfPeriod",
    "name": "时间范围内取最大值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "timeProp",
        "name": "比较时间字段",
        "type": "string"
      },
      {
        "key": "valueProp",
        "name": "取值字段",
        "type": "string"
      },
      {
        "key": "startTime",
        "name": "起始时间",
        "type": "string"
      },
      {
        "key": "endTime",
        "name": "结束时间",
        "type": "string"
      }
    ],
    "description": `【功能】在指定时间范围内，取子表某字段的最大值（参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【timeProp】比较时间字段（字段类型应为时间类型）
        【valueProp】取值字段（字段类型应为数字类型）
        【startTime】起始时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
        【endTime】结束时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
    【返回值】时间范围内，子表某字段的最大值
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段，出差日期date字段
        【需求】获取2022-10-01到2022-10-07时间段内，哪一天的出差费用money最大
        【举例】时间范围内取最大值("Order.trips","date","money","2022-10-01","2022-10-07")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "AvgValueOfPeriod",
    "name": "时间范围内取平均值",
    "params": [
      {
        "key": "table",
        "name": "主表.子表",
        "type": "string"
      },
      {
        "key": "timeProp",
        "name": "比较时间字段",
        "type": "string"
      },
      {
        "key": "valueProp",
        "name": "取值字段",
        "type": "string"
      },
      {
        "key": "startTime",
        "name": "起始时间",
        "type": "string"
      },
      {
        "key": "endTime",
        "name": "结束时间",
        "type": "string"
      }
    ],
    "description": `【功能】在指定时间范围内，取子表某字段的平均值（所有参数用""包起来）
    【参数】
        【table】主表.子表（链式结构）
        【timeProp】比较时间字段（字段类型应为时间类型）
        【valueProp】取值字段（字段类型应为数字类型）
        【startTime】起始时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
        【endTime】结束时间（支持'yyyy-MM-dd' 或 'yyyy-MM-dd hh:mm:ss'）
    【返回值】时间范围内，子表某字段的平均值
    【示例】
        【场景】提交单据Order，单据包含差旅明细子表trips，子表包含出差费用money字段，出差日期date字段
        【需求】获取2022-10-01到2022-10-07时间段内，平均的出差费用money是多少
        【举例】时间范围内取平均值("Order.trips","date","money","2022-10-01","2022-10-07")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetSessionValue",
    "name": "获取会话变量",
    "params": [
      {
        "key": "name",
        "name": "名称",
        "type": "string"
      }
    ],
    "description": `【功能】获取用户会话变量的值
    【参数】
        【name】会话变量名
    【返回值】对象(object)
    【示例】
        【举例】获取会话变量("会话变量一")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetContextParameter",
    "name": "获取上下文变量",
    "params": [
      {
        "key": "name",
        "name": "名称",
        "type": "string"
      }
    ],
    "description": `【功能】获取上下文变量的值
    【参数】
        【name】上下文变量名
    【返回值】对象(object)
    【示例】
        【举例】获取上下文变量("上下文变量一")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "getComputeJsonData",
    "name": "根据属性名获取JSON串"
  },
  {
    "key": "GetInjectedEntity",
    "name": "根据注入名获取注入对象",
    "params": [
      {
        "key": "name",
        "name": "注入名",
        "type": "string"
      }
    ],
    "description": `【功能】获取运行时注入对象的实际对象(参数用""包起来），不支持获取属性    
    【参数】
        【name】注入名
    【返回值】对象(object)
    【示例】
        【举例】根据注入名获取注入对象("注入名")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetChainedPropertyValue",
    "name": "根据属性名获取属性值",
    "params": [
      {
        "key": "property",
        "name": "属性名",
        "type": "string"
      }
    ],
    "description": `【功能】：获取运行时注入属性的实际值(参数用""包起来）
    【参数】
        【property】属性名
    【返回值】对象(object)
    【示例】
        【举例】根据属性名获取属性值("属性名")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ParseEnum",
    "name": "枚举取值",
    "params": [
      {
        "key": "name",
        "name": "枚举字段",
        "type": "string"
      },
      {
        "key": "map",
        "name": "枚举集合",
        "type": "obj"
      },
    ],
    "description": `【功能】：将枚举解析为显示值【返回值类型】：数字或字符串\n【示例】：枚举显示值(SysApproval.version,Enum.SysApproval.version) == '通过'【返回值】："true"`,
    "type": "Special",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]